import React, { useState, useEffect } from "react";

// common function
import { windWeatherStationLatLon } from "../scripts/station";
import { windMarker } from "../scripts/windMarker";
import { fetchingTime } from "../../../../config/fetching";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/windMap.scss";
// mapTitle sheet
import "../scss/mapTitleMap.scss";

// leaflet css
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";

// Openstreetmap components
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  ZoomControl,
  useMapEvents,
} from "react-leaflet";

// L component
import Leaflet from "leaflet";

// Watermark
import Watermark from "../../../../resources/image/watermark.jpg";

import { getWindInformation } from "../../../service/apiWeatherInfoService";

//#region Map Watermark
const WatermarkControl = () => {
  const map = useMap();
  const watermark = map.getContainer().querySelector(".watermark");

  if (!watermark) {
    const watermark = new Leaflet.Control({ position: "bottomleft" });
    watermark.onAdd = function (map) {
      var div = Leaflet.DomUtil.create("div", "watermark");
      div.innerHTML = "<img src='" + Watermark + "' width='75' height='75'>";
      return div;
    };
    watermark.addTo(map);
    // React.useEffect(() => {

    // }, [map]);
  }

  return null;
};

//#endregion END

//#region Map legend
const Legend: React.FC = () => {
  const map = useMap();

  React.useEffect(() => {
    const legend = new Leaflet.Control({ position: "bottomright" });

    var categories = [
      "17級以上",
      "16-17級",
      "14-15級",
      "12-13級",
      "10-11級",
      "8-9級",
      "6-7級",
      "0-5級",
      "風向不定/故障",
      "沒有資料",
    ];
    var color_categories = [
      "#FF00FF",
      "#F79646",
      "#ccaaa9",
      "red",
      "blue",
      "green",
      "black",
      "gray",
      "circle",
      "M",
    ];

    legend.onAdd = function () {
      const div = Leaflet.DomUtil.create("div", "legend");
      // loop through our categories and generate a label with an icon for each one
      for (var i = 0; i < categories.length; i++) {
        switch (color_categories[i]) {
          case "circle":
            div.innerHTML += `${categories[i]}<span class="dot" height="15" width="15"></span><br>`;
            break;
          case "M":
            div.innerHTML += `${categories[i]} M<br>`;
            break;
          default:
            div.innerHTML += `${categories[i]} <span class="square" height="15" width="15" style="background-color:${color_categories[i]}"></span><br>`;
            break;
        }
      }
      return div;
    };

    legend.addTo(map);

    // Cleanup function to remove the legend when the component is unmounted
    return () => {
      legend.remove();
    };
  }, [map]);

  return null;
};
//#endregion END

type Props = { enable: number; autoUpdate?: boolean };
type windInfo_Props = {
  station: string;
  wind_mean: string;
  wind_dir: string;
  time: string;
};

function WindMap({ enable, autoUpdate }: Props) {
  const [isMapOn, setIsMapOn] = useState<React.Key>(0);
  const [windArray, setWindArray] = useState<Array<windInfo_Props>>([]);
  const [time, setTime] = useState<string>("");

  const [zoomLevel, setZoomLevel] = useState<number>(11);

  const position: Leaflet.LatLngExpression = [22.35, 114.125];

  // zoom change
  const ZoomListener = () => {
    useMapEvents({
      zoomend: (event) => {
        const map = event.target;
        const zoom = map.getZoom();

        setZoomLevel(zoom);
      },
    });
    return null;
  };

  async function getFetchWindInfomation() {
    await getWindInformation()
      .then((response) => {
        return response.data.data;
      })
      .then((data) => {
        setWindArray(data);
        setTime(data[0].time);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      if (autoUpdate === true) {
        getFetchWindInfomation();
      }
    };

    getFetchWindInfomation(); // Initial fetch

    let intervalId = setInterval(() => {
      fetchData();
    }, fetchingTime);

    return () => {
      clearInterval(intervalId);
    };
  }, [autoUpdate]);

  useEffect(() => {
    setIsMapOn(enable);

    // Reset the zoom level
    setZoomLevel(11);
  }, [enable]);

  return (
    <div className="mapContainer">
      <MapContainer
        zoom={11}
        maxZoom={12}
        minZoom={11}
        zoomControl={false}
        center={position}
        scrollWheelZoom={false}
        key={isMapOn}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <ZoomControl position="topright" />

        <WatermarkControl />

        <Legend />

        <ZoomListener />

        {windArray.map((item) => {
          if (item.station === "Star Ferry" && zoomLevel === 11) {
            return null;
          } else {
            return (
              <Marker
                key={"wind-" + item.station}
                position={windWeatherStationLatLon(item.station)}
                icon={windMarker(item.wind_mean, item.wind_dir)}
              />
            );
          }
        })}
      </MapContainer>
      <div className="mapDescription">
        <div>各地風向及風速</div>
        <div>
          {time.substr(4, 2)}月{time.substr(6, 2)}日 {time.substr(8, 2)}:
          {time.substr(10, 2)}更新
        </div>
      </div>
    </div>
  );
}

export default WindMap;
